import { timeout } from '../helpers/base'

let $activeInput = null

$(document).on('click', '.ui-datepicker-close', function() {
	if ( $activeInput && $activeInput.length) {
		$activeInput.val('')
		inactiveJut($activeInput, '')
		window.$.datepicker._getInst($activeInput[0]).settings._onClear()
	}
})

const activeJut = function($elm) {
	const hasJut = $elm.parent().attr('data-se') === 'inputJut'
	if (hasJut) {
		$elm.parent().addClass('active')
		$elm.parent().removeClass('inactive')
	}
}

const inactiveJut = function($elm, val) {
	const hasJut = $elm.parent().attr('data-se') === 'inputJut'
	if (hasJut && !val.length) {
		$elm.parent().addClass('inactive')
		$elm.parent().removeClass('active')
	}
}

const createDefaults = function() {
	return {
		dateFormat: 'dd-mm-yy',
		duration: 'fast',
		showButtonPanel: true,
		closeText: 'Clean',
		beforeShow(input) {
			const $elm = $(input)
			activeJut($elm)

			timeout(()=> { $activeInput = $elm }, 20)
		},
		onClose(val) {
			const $elm = $(this)
			inactiveJut($elm,val)

			timeout(() => { $activeInput = null}, 10);
		},
		_onClear() {}
	}
};


/**
 * Create jQuery UI datepickers with some defaults
 * @example
	$_GP.fn.datepicker('#form input', {
		minDate: "0D",
		changeMonth: true,
		changeYear: true,
	});
 * @param {string|jQuery} elm - base element
 * @param {object} opt - jQuery UI datepicker options
 * @returns {object} jQuery datepicker object
 */
export function datepicker(elm, opt) {

	const $elm = $(elm);
	if (!$elm.length) return;

	const defaults = createDefaults()

	var options = $.extend({}, defaults, opt);

	return $elm.datepicker(options).on('focus', function(){
		$(this).trigger('blur');
	});
}

export function datepickerRun() {
	const $dp = $('[data-dp]')
	if (!$dp.length) return

	const defaults = createDefaults()

	$dp.each((i,elm)=> {
		const $elm = $(elm);
		const opt = $elm.data('dp') || {}
		const options = $.extend({}, defaults, opt);

		$elm.datepicker(options).on('focus', function(){
			$(this).trigger('blur');
		});
	})
}
